import React, { Component } from "react";
import styled from "styled-components";
import { ChevronDown } from "react-feather";
import {
  LargeTitle,
  InfoParagraph,
  SmallMargin,
  lightest,
  Contain,
  MediumTitle,
  gray,
  ContainWPadding,
  lighter,
  light,
  SmallTitle,
  Margin
} from "../Tools/Variables";

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  min-height: 490px;

  margin-bottom: 100px;
  display: flex;
  justify-content: space-around;

  @media screen and (max-width: 750px) {
    flex-direction: column;
  }
`;

const TitleWrapper = styled.div`
  min-width: 200px;
  margin-right: 30px;
  flex-grow: 1;
`;
const QuestionWrapper = styled.div`
  min-width: 200px;

  max-width: 600px;
  padding: 0;
  box-sizing: border-box;
`;
const AnswerContainer = styled.div`
  transition: 0.3s ease-in-out;
  overflow: hidden;

  max-height: ${props => (props.show ? "300px" : "0px")};
`;

const QuestionContainer = styled.div`
  pointer: cursor;
  border-bottom: 1px solid ${lighter};
  cursor: pointer;
  min-height: 20px;
  display: flex;
  flex-direction: column;
`;

class Question extends Component {
  state = {
    showAnswer: false
  };

  setSwitchShowAnswer = index => {
    this.setState(prevState => ({ showAnswer: !prevState.showAnswer }));
  };
  setHideAnswer = index => {
    this.setState({ showAnswer: false });
    console.log("tja");
  };

  render() {
    return (
      <div className={this.props.GtmClass}>
        <QuestionContainer
          onClick={this.setSwitchShowAnswer}
          className={this.props.GtmClass}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <MediumTitle
              style={{ margin: "17px 0" }}
              className={this.props.GtmClass}
            >
              {this.props.question}
            </MediumTitle>

            <div
              style={{
                transition: "0.3s ease-in-out",
                transform: this.state.showAnswer
                  ? "rotate(180deg)"
                  : " rotate(0deg)",
                tranformOrigin: "center"
              }}
            >
              <ChevronDown
                id="test"
                size={18}
                style={{ verticalAlign: "sub" }}
                className={this.props.GtmClass}
              />
            </div>
          </div>
          <AnswerContainer show={this.state.showAnswer}>
            <InfoParagraph>
              {this.props.children}
              <SmallMargin />
            </InfoParagraph>
          </AnswerContainer>
        </QuestionContainer>
      </div>
    );
  }
}
class FAQ extends Component {
  render() {
    return (
      <ContainWPadding>
        <Wrapper>
          <TitleWrapper>
            <LargeTitle>Faq</LargeTitle>
            <SmallMargin />
            <SmallTitle style={{ color: light }}>Kontakta oss</SmallTitle>
            <SmallMargin />
            <MediumTitle>info@modilect.se</MediumTitle>
          </TitleWrapper>
          <QuestionWrapper>
            <Question
              GtmClass={"FAQWrapper1"}
              question={"Hur kan jag veta att sängens fasthet passar mig?"}
            >
              Alla våra premiumsängar har justerbar fasthet vilket innebär att du
              med en fjärrkontroll kan justera hur hård eller mjuk du vill att
              de vitala zonerna i sängen skall vara. Du kan därför alltid göra
              ett tryggt köp utan oro för att du måste leva med ett felaktigt
              val.
            </Question>

            <Question
              GtmClass={"FAQWrapper2"}
              question={
                "Kan sängens justering ge samma fasthet som en konventionell säng?"
              }
            >
              Våra justerbara sängar erbjuder ett större spektrum än en
              standardsäng. Från mycket fast, vilket är lämpligt för svank, till
              extra mjuk, vilket passar axelpartiet. Du kan när du vill ändra
              steglöst inom hela spektrumet.
            </Question>

            <Question
              GtmClass={"FAQWrapper3"}
              question={"Hur ser garantierna ut?"}
            >
              Vi lämnar garantier enligt branschstandard för premium- och
              premiumsängar. Normalt när du köper säng ingår inte skydd mot
              avmattning av fjädrar. Ett problem som du inte behöver oroa dig
              för i våra sängar då du alltid kan justera fjädrarnas fasthet med
              en fjärrkontroll.
            </Question>
            <Question
              GtmClass={"FAQWrapper4"}
              question={
                "Även om jag inte behöver prova ut sängens fasthet vill jag ändå prova sängen, var kan jag göra det?"
              }
            >
              Vi samarbetar med hotell så att du alltid kan provsova sängen
              innan köp. Om du väljer att köpa vår justerbara säng dras det
              rabatterade hotellpriset av från den totala köpesumman. Vi
              etablerar även showrooms så att du kan få en första bekantskap med
              sängen innan du provsover en natt.
            </Question>
          </QuestionWrapper>
        </Wrapper>
      </ContainWPadding>
    );
  }
}

export default FAQ;



// WEBPACK FOOTER //
// ./src/Home/Faq.js